/*
 * Get-profile.ts
 * Description: Includes the declaration of a function
 * for getting the profile of a user
 */

// Importing Axios for HTTP requests
import Axios from 'axios';
// Importing variables
import {APIURL} from '@/ts/variables';

/**
 * Getting user data
 *
 * @return {Object} Promise - user data is sent when the promise is resolved
 */
export function getProfile() {
    const jwt = localStorage.getItem('jwt');
    // Creating a new instance of Promise to make JavaScript work synchronous
    return new Promise ((resolve, reject) => {
        Axios({
            url:  APIURL + 'auth/user',
            method: 'get',
            headers: {
                Authorization: 'Bearer ' + jwt,
            },
            data: {},
        }).then((response) => {
            resolve(response.data.data.attributes);
        }).catch(() => {
            reject();
        });
    });
}
